module.exports = __webpack_public_path__ + "../assets/main-logo-bg-left.png";